<template>
  <div class="c-undo">
    <div @click="onClick" :class="{ disabled: history.length < 2 }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { deepCopy } from "@/utils";
export default {
  name: "CUndo",
  props: {
    data: [Object, Array],
  },
  data() {
    return {
      time: new Date().getTime(),
      history: [],
    };
  },
  methods: {
    onClick() {
      if (this.history.length > 1) {
        const newHistory = [...this.history];
        newHistory.pop();
        this.history = newHistory;
        this.$emit("undo", newHistory[newHistory.length - 1]);
      }
    },
  },
  watch: {
    data(data) {
      const newTime = new Date().getTime();
      let newHistory = [...this.history];
      if (data === newHistory[newHistory.length - 1]) {
        if (newHistory.length === 1) {
          newHistory = deepCopy(newHistory);
        }
      } else {
        if (newTime - this.time < 500 && newHistory.length > 1) {
          newHistory.pop();
        }
        newHistory.push(deepCopy(data));
        if (newHistory.length > 20) {
          newHistory.shift();
        }
      }
      this.time = newTime;
      this.history = newHistory;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-undo {
  .disabled {
    cursor: not-allowed;

    * {
      cursor: not-allowed !important;
    }
  }
}
</style>
